module.exports = __webpack_public_path__ + "img/jd_unicom.03b13f67.png";